import React from 'react';
import { withTranslation } from 'react-i18next';


class DefaultErrorWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const { error, info, t } = this.props;
    return (
      <span className="error">{t('error', { error, info })}</span>
    );
  }
}

const localizedDefaultErrorWrapper = withTranslation('account')(DefaultErrorWrapper);

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidCatch(error, info) {
    this.setState({ error: { error, info } });
    console.error('Unexpected error!', error, info);
  }

  render() {
    const { ErrorWrapper } = this.props;

    if (this.state.error) {
      return (
        <ErrorWrapper error={this.state.error} info={this.state.info} />
      );
    }
    return this.props.children;
  }
}

ErrorBoundary.defaultProps = {
  children: null,
  ErrorWrapper: localizedDefaultErrorWrapper,
}

export default (ErrorBoundary);
